// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DatasetVersionCreate,
  DatasetVersionCreateFromJSON,
  DatasetVersionCreateToJSON,
} from "../models/DatasetVersionCreate";
import {
  type DatasetVersionRead,
  DatasetVersionReadFromJSON,
  DatasetVersionReadToJSON,
} from "../models/DatasetVersionRead";
import {
  type DatasetVersionUpdate,
  DatasetVersionUpdateFromJSON,
  DatasetVersionUpdateToJSON,
} from "../models/DatasetVersionUpdate";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageDatasetVersionRead,
  PageDatasetVersionReadFromJSON,
  PageDatasetVersionReadToJSON,
} from "../models/PageDatasetVersionRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface DatasetVersionCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  datasetVersionCreate: DatasetVersionCreate;
}

export interface DatasetVersionDestroyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  versionNumber: number;
}

export interface DatasetVersionListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: DatasetVersionListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
}

export interface DatasetVersionRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  versionNumber: number;
}

export interface DatasetVersionUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  versionNumber: number;
  /**
   *
   */
  datasetVersionUpdate: DatasetVersionUpdate;
}

/**
 *
 */
export class DatasetVersionsApi extends runtime.BaseAPI {
  /**
   * Creates request options for datasetVersionCreate without sending the request
   */
  async datasetVersionCreateRequestOpts(
    requestParameters: DatasetVersionCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetVersionCreate().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetVersionCreate().'
      );
    }

    if (requestParameters["datasetVersionCreate"] == null) {
      throw new runtime.RequiredError(
        "datasetVersionCreate",
        'Required parameter "datasetVersionCreate" was null or undefined when calling datasetVersionCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/versions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: DatasetVersionCreateToJSON(requestParameters["datasetVersionCreate"]),
    };
  }

  /**
   * Create a new draft version of a dataset for a specific project.
   * create new dataset version
   */
  async datasetVersionCreateRaw(
    requestParameters: DatasetVersionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DatasetVersionRead>> {
    const requestOptions = await this.datasetVersionCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DatasetVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Create a new draft version of a dataset for a specific project.
   * create new dataset version
   */
  async datasetVersionCreate(
    requestParameters: DatasetVersionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DatasetVersionRead> {
    const response = await this.datasetVersionCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetVersionDestroy without sending the request
   */
  async datasetVersionDestroyRequestOpts(
    requestParameters: DatasetVersionDestroyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetVersionDestroy().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetVersionDestroy().'
      );
    }

    if (requestParameters["versionNumber"] == null) {
      throw new runtime.RequiredError(
        "versionNumber",
        'Required parameter "versionNumber" was null or undefined when calling datasetVersionDestroy().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/versions/{version_number}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );
    urlPath = urlPath.replace(
      "{version_number}",
      encodeURIComponent(String(requestParameters["versionNumber"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a specific version of a dataset.
   * delete a dataset version
   */
  async datasetVersionDestroyRaw(
    requestParameters: DatasetVersionDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.datasetVersionDestroyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a specific version of a dataset.
   * delete a dataset version
   */
  async datasetVersionDestroy(
    requestParameters: DatasetVersionDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.datasetVersionDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for datasetVersionList without sending the request
   */
  async datasetVersionListRequestOpts(
    requestParameters: DatasetVersionListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetVersionList().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetVersionList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/versions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of dataset versions.
   * list dataset versions
   */
  async datasetVersionListRaw(
    requestParameters: DatasetVersionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageDatasetVersionRead>> {
    const requestOptions = await this.datasetVersionListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PageDatasetVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Return a list of dataset versions.
   * list dataset versions
   */
  async datasetVersionList(
    requestParameters: DatasetVersionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageDatasetVersionRead> {
    const response = await this.datasetVersionListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetVersionRetrieve without sending the request
   */
  async datasetVersionRetrieveRequestOpts(
    requestParameters: DatasetVersionRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetVersionRetrieve().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetVersionRetrieve().'
      );
    }

    if (requestParameters["versionNumber"] == null) {
      throw new runtime.RequiredError(
        "versionNumber",
        'Required parameter "versionNumber" was null or undefined when calling datasetVersionRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/versions/{version_number}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );
    urlPath = urlPath.replace(
      "{version_number}",
      encodeURIComponent(String(requestParameters["versionNumber"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve a specific version of a dataset.
   * retrieve a dataset version
   */
  async datasetVersionRetrieveRaw(
    requestParameters: DatasetVersionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DatasetVersionRead>> {
    const requestOptions = await this.datasetVersionRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DatasetVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Retrieve a specific version of a dataset.
   * retrieve a dataset version
   */
  async datasetVersionRetrieve(
    requestParameters: DatasetVersionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DatasetVersionRead> {
    const response = await this.datasetVersionRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetVersionUpdate without sending the request
   */
  async datasetVersionUpdateRequestOpts(
    requestParameters: DatasetVersionUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetVersionUpdate().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetVersionUpdate().'
      );
    }

    if (requestParameters["versionNumber"] == null) {
      throw new runtime.RequiredError(
        "versionNumber",
        'Required parameter "versionNumber" was null or undefined when calling datasetVersionUpdate().'
      );
    }

    if (requestParameters["datasetVersionUpdate"] == null) {
      throw new runtime.RequiredError(
        "datasetVersionUpdate",
        'Required parameter "datasetVersionUpdate" was null or undefined when calling datasetVersionUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/versions/{version_number}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );
    urlPath = urlPath.replace(
      "{version_number}",
      encodeURIComponent(String(requestParameters["versionNumber"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: DatasetVersionUpdateToJSON(requestParameters["datasetVersionUpdate"]),
    };
  }

  /**
   * Update an existing dataset version\'s metadata or status.
   * update an existing dataset version
   */
  async datasetVersionUpdateRaw(
    requestParameters: DatasetVersionUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DatasetVersionRead>> {
    const requestOptions = await this.datasetVersionUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DatasetVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Update an existing dataset version\'s metadata or status.
   * update an existing dataset version
   */
  async datasetVersionUpdate(
    requestParameters: DatasetVersionUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DatasetVersionRead> {
    const response = await this.datasetVersionUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const DatasetVersionListOrderByEnum = {
  VersionNumber: "version_number",
  VersionNumber2: "-version_number",
} as const;
export type DatasetVersionListOrderByEnum =
  (typeof DatasetVersionListOrderByEnum)[keyof typeof DatasetVersionListOrderByEnum];
